import { Box, Typography } from "@material-ui/core";
import React from "react";

import { UserPageDescriptionGrid } from "./UserPageDescriptionGrid";
import { DescriptionBox } from "./DescriptionBox";
import { DescriptionImageBox } from "./DescriptionImagebox";
import { UserPageDescriptionWrapper } from "./UserPageExplanationWrapper";

export const UserPageDescriptionControl: React.FunctionComponent = () => {
    return (
        <UserPageDescriptionWrapper>
            <UserPageDescriptionGrid id="descriptiongrid" mobileColumns={"1fr"} tabletColumns={"1fr 1fr"} desktopColumns={"1fr 1fr"}>
                <DescriptionBox>
                    <Box className="bugetQuote" />
                    <Box>
                        <Typography className="budgetcaption">
                            Budget quote provides project pricing for roof coatings and gutter refurbishment systems: Seamsil®, Delcote ®, Delglaze ®, Plygene® and Delcote GS
                        </Typography>
                    </Box>

                    {/*                     <Box className="descriptionGutter">
                        <Box>
                            <Typography className="sectiontitle">Gutter refurbishment</Typography>
                        </Box>
                        <ul>
                            <li>Plygene® gutterline system</li>
                            <li>Delcote GS gutter coating system</li>
                        </ul>
                    </Box> */}
                    {/*                     <Box className="descriptionRoof">
                        <Box>
                            <Typography className="sectiontitle">Roof refurbishment</Typography>
                        </Box>
                        <ul>
                            <li>Seamsil® cut edge corrosion system</li>
                            <li>Delcote® architectural full roof coating system</li>
                            <li>Delglaze® rooflight system</li>
                        </ul>
                    </Box> */}
                </DescriptionBox>
                <DescriptionImageBox />
            </UserPageDescriptionGrid>
        </UserPageDescriptionWrapper>
    );
};
